export default __webpack_public_path__ + "static/media/complementary--steep-ascent--g1.530757ce.png";